import { useQuery } from '@apollo/client';
import { Button, useModal } from '@serodigital/ui-components';
import * as React from 'react';
import { useEffect } from 'react';
import {
  FirmwareVersionsQueryVariables,
  FirmwareVersions,
  FirmwareVersionsQuery,
  UpgradeFirmware,
  UpgradeFirmwareMutation,
  UpgradeFirmwareMutationVariables,
} from '../../../../shared/api-clients/gql';
import { FirmwareUpgradeModal } from '../../components/modal/firmwareUpgradeModal';
import { useManagementClient } from '../../contexts/managementClient';

interface IProps {
  deviceId: string;
  refetch: () => void;
}

export function Firmware({ deviceId, refetch }: IProps) {
  const { client } = useManagementClient();
  const { isOpen, toggle } = useModal();
  const [firmwareVersions, setFirmwareVersions] = React.useState<string[]>([]);

  const { data, loading } = useQuery<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>(FirmwareVersions, {
    variables: { deviceId },
  });

  useEffect(() => {
    if (!data) return;
    setFirmwareVersions(data?.firmwareVersions?.firmwareVersions);
  }, [data]);

  const upgradeFirmware = async selectedFirmwareVersion => {
    await client.run<UpgradeFirmwareMutation, UpgradeFirmwareMutationVariables>(UpgradeFirmware, {
      upgradeFirmware: { deviceId, file: selectedFirmwareVersion },
    });
    refetch();
    toggle();
  };

  return (
    <div className="flex justify-center">
      <Button disabled={loading} data-qa="firmware-upgrade-open-button" size="small" onClick={toggle}>
        Firmware Upgrades
      </Button>
      <FirmwareUpgradeModal
        toggle={toggle}
        isOpen={isOpen}
        firmwareVersions={firmwareVersions}
        upgradeFirmware={upgradeFirmware}
      />
    </div>
  );
}
